import styled from 'styled-components'

import { motion } from 'framer-motion'

export const Container = styled(motion.div)`
  display: flex;
`
